import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataTableSortEnum, DataTableStateModel } from 'app/shared/components/dynamic-table/dynamic-table.model';
import { HelperService } from 'app/shared/services/helper.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeDashboardService {

  constructor(private http: HttpClient, private helperService: HelperService) { }

  getElkDashboardList(data: DataTableStateModel): Observable<any> {
    data = this.helperService.replaceFilterBlanksSelection(data);

    let params: any = {
      skipCount: data.showItemsPerPage * (data.pageNumber - 1),
      takeCount: data.showItemsPerPage,
      isOrderByDescending: data.sortingValue.dir === DataTableSortEnum.SORT_DESC ? true : false,
      orderField: data.sortingValue.prop ? data.sortingValue.prop : undefined,
      fieldFilters: data.datatableFilters || []
    };

    const url = `/v1/elksearch-case/dashboard?dashboardType=${data.tableType}`;
    return this.http.post(url, params);
  }

  getStatisticCaseCards(data: DataTableStateModel): Observable<any> {
    data = this.helperService.replaceFilterBlanksSelection(data);
    
    const params: any = {
      fieldFilters: data.datatableFilters || [], 
      orderField: data.sortingValue?.prop || null,
      isOrderByDescending: data.sortingValue?.dir === DataTableSortEnum.SORT_DESC,
      skipCount: null, 
      takeCount: null
    };

    const url = `/v1/elksearch-case/dashboard/count`;
    return this.http.post(url, params);
  }
}
